module.exports = __webpack_public_path__ + "static/media/fleet-efficiency-active.621a9d7e.svg";